import { API_KEY } from "@grudder/lib/const";
import { config } from "@grudder/lib/config";
import { AUTH_GET, AUTH_PUT } from "@grudder/app/actions-server";

export interface InvitationDetails {
  _id: string;
  email: string;
  role: {
    _id: string;
    name: string;
    weightAge: number;
    id: string;
  };
  invitedBy: {
    _id: string;
    fullName: string;
    email: string;
    userGroups: any[];
    createdAt: string;
    updatedAt: string;
    __v: number;
    authenticationId: string;
    isActive: boolean;
    id: string;
  };
  organization: {
    _id: string;
    name: string;
    id: string;
  };
  status: string;
  createdAt: string;
  updatedAt: string;
  __v: number;
  id: string;
}

/**
 * Fetch invitation details by invitation ID
 */
export async function getInvitationDetails(invitationId: string): Promise<InvitationDetails | null> {
  try {
    const response = await AUTH_GET(`${config.baseURL}/api/users/invites/${invitationId}`);
    console.log("getInvitationDetails response", response); ``
    return response;
  } catch (error) {
    console.error('Error fetching invitation details:', error);
    return null;
  }
}

/**
 * Accept an invitation
 */
export async function acceptInvitation(invitationId: string, userId: string, email: string): Promise<{ success: boolean; message?: string; organizationDomain?: string }> {
  try {
    const response = await AUTH_PUT(
      `${config.baseURL}/api/users/invites/${invitationId}/verify`,{
        user: userId,
        email: email
      }
    );

    // AUTH_PUT now returns a plain object with success/error info
    if (!response.success) {
      return { success: false, message: response.message || "Failed to accept invitation" };
    }

    const data = response.data;

    // Return the organization domain if provided in the response
    // The API response should include the organization domain after successful acceptance
    return {
      success: true,
      organizationDomain: data.organizationDomain || data.organization?.domain
    };
  } catch (error) {
    console.error("Error accepting invitation:", error);
    return { success: false, message: "An unexpected error occurred. Please try again." };
  }
}

/**
 * Decline an invitation
 */
export async function declineInvitation(invitationId: string, userId: string): Promise<{ success: boolean; message?: string }> {
  try {
    const response = await fetch(`${config.baseURL}/api/users/invite/decline/${invitationId}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'api-key': API_KEY
      },
      body: JSON.stringify({ user: userId })
    });

    if (!response.ok) {
      const data = await response.json();
      return { success: false, message: data.message || "Failed to decline invitation" };
    }

    return { success: true };
  } catch (error) {
    console.error("Error declining invitation:", error);
    return { success: false, message: "An unexpected error occurred. Please try again." };
  }
}
